import type { Route } from './+types/projects';
import { useSearchParams } from 'react-router';
import { ProjectsDocument } from '~/components/projects/ProjectsDocument';
import { cvLocale, issuedStamp } from '~/lib/cvData';
import { absoluteUrl, socialMeta } from '~/lib/site';

export function meta() {
  const title = 'Projects – Jolan De Nef';
  const description = 'A printed selection of interactive 3D experiences by Jolan De Nef, creative developer based in Mechelen, Belgium.';

  return [
    { title },
    { name: 'description', content: description },
    ...socialMeta({ title, description, url: absoluteUrl('/projects') }),
  ];
}

/**
 * @param request - Incoming request, used to read the `lang` search param
 * @returns The localised issued date for the dossier cover
 */
export function loader({ request }: Route.LoaderArgs) {
  return issuedStamp(cvLocale(new URL(request.url)));
}

/**
 * @returns The print-first projects dossier route — reads `?lang=nl` (default: en) and the
 * server-stamped issued date; use the browser's Save-as-PDF to export
 */
export default function Projects({ loaderData }: Route.ComponentProps) {
  const [params] = useSearchParams();
  return <ProjectsDocument locale={cvLocale(params)} issued={loaderData.issued} />;
}
